import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component({})
export default class PopupDeleteBriefingComponent extends Vue {
  @appStoreState.Getter
  public getIsShowDeleteBriefing!: boolean;

  @appStoreState.Getter
  public getIsDeleteSingleBriefing!: boolean;

  @appStoreState.Getter
  public getCurrentDeleteBriefingName!: string;

  @appStoreState.Getter
  public getNumberOfDeleteBriefings!: number;

  @appStoreState.Mutation
  public setIsShowDeleteBriefing!: (payload: any) => void;

  @appStoreState.Mutation
  public setIsDeleteSingleBriefing!: (payload: any) => void;

  @appStoreState.Mutation
  public setCurrentDeleteBriefingName!: (payload: any) => void;

  @appStoreState.Mutation
  public setNumberOfDeleteBriefings!: (payload: any) => void;

  @appStoreState.Getter
  public getIsLoadingDeleteBriefing!: boolean;

  emitHandleDeleteBriefings() {
    this.$emit('handleDeleteBriefings');
  }

  emitHandleDeleteSingleBriefing() {
    this.$emit('handleDeleteSingleBriefing');
  }

  handleCancelDelete() {
    this.setIsShowDeleteBriefing(false);
    this.setCurrentDeleteBriefingName('');
    this.setNumberOfDeleteBriefings(0);
  }
}
